import axios from "axios";
import Cookies from "js-cookie";
import store from "redux/store";
import { clearCurrentUserData, setUserRefreshData, setUserSavedAccounts } from "redux/users/actions";
import { authorizationService } from "api";
import { removeUserSavedAccounts } from "utils/LocalStorageHelper";

export const KeyCloakConfig = {
    react: {
        grant_type: 'password',
        client_id: process.env.REACT_APP_KEYCLOAK_CLIENT_ID || 'react-client-1'
    },
    refresh: {
        grant_type: 'refresh_token',
        client_id: process.env.REACT_APP_KEYCLOAK_CLIENT_ID || 'react-client-1',
    },
    cookie: {
        domain: process.env.REACT_APP_COOKIE_DOMAIN || 'localhost',
        expires: process.env.REACT_APP_COOKIE_EXPIRES || 30
    }
}

export const apiGateway = {
    sellers: `${process.env.REACT_APP_API_GATEWAY_URL}/api/v2/sellers`,
    // warehouses: `${process.env.REACT_APP_API_GATEWAY_URL}/api/v1/warehouses`
    sticker: `${process.env.REACT_APP_API_GATEWAY_URL}/stickers`,
    customBarcode: `${process.env.REACT_APP_LEGACY_APP_URL}/api/v1/stickers/download`,
    barcode: `${process.env.REACT_APP_LEGACY_APP_URL}/api/v1/product/generate-barcodes-for-market`,
    warehouses: `${process.env.REACT_APP_API_GATEWAY_TEST}/api/v1/warehouses`,
    stocks: `${process.env.REACT_APP_API_GATEWAY_TEST}/stocks/api/v1`,
    stocksExport: `${process.env.REACT_APP_API_GATEWAY_TEST}/stocks-export/api/v1`,
    stocksReserve: `${process.env.REACT_APP_API_GATEWAY_TEST}/stocks-reserve/api/v1`,
    orders: `${process.env.REACT_APP_LEGACY_APP_URL}/api/internal/v1/orders`,
    legacyPublicAPIv1: `${process.env.REACT_APP_LEGACY_APP_URL}/api/v1`,
    legacyPublicAPIv2: `${process.env.REACT_APP_LEGACY_APP_URL}/api/v2`,
    legacyPublicAPIv3: `${process.env.REACT_APP_LEGACY_APP_URL}/api/v3`,
    billing: `${process.env.REACT_APP_BILLING_API_URL}/api/v1/billing`,
}

const api = axios.create();

api.interceptors.request.use(request => {
    request.headers.Authorization = `Bearer ${store.getState().users.currentUser.data.accessToken}`;
    return request;
}, error => {
    return Promise.reject(error);
})

// TODO: Обработать Infinite loop, если нам второй раз после обновления токена originalRequest вернет 401 обработать это

api.interceptors.response.use(response => {
    return response
}, async error => {
    const originalRequest = error.config;
    if(error.response.status === 401 && originalRequest && !originalRequest._isRetried) {
        originalRequest._isRetried = true;
        if(Cookies.get("jwt_refresh") && Cookies.get("currentUserId")) {
            try {
                const data = {
                    refreshToken: Cookies.get("jwt_refresh"),
                    id: Cookies.get("currentUserId")
                }

                const response = await authorizationService.refresh(data);

                if(response.status > 300) {
                    throw new Error("User not authorized")
                }

                const responseData = await response.json();

                store.dispatch(setUserRefreshData(responseData));

                return api.request(originalRequest);

            } catch (error) {
                console.error(error.message)
                const savedAccounts = removeUserSavedAccounts({ id: Cookies.get("currentUserId") });
                store.dispatch(setUserSavedAccounts(savedAccounts));
                store.dispatch(clearCurrentUserData());
                window.location.href = `${process.env.REACT_APP_AUTH_APP_ADD_ACCOUNT_URL}`;
            }
        }
    }
})

export { api };
